/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getProgramDerivedAddress,
  getStructDecoder,
  getStructEncoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
  SolanaError,
  transformEncoder,
  type AccountMeta,
  type AccountSignerMeta,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type Instruction,
  type InstructionWithAccounts,
  type InstructionWithData,
  type ReadonlyAccount,
  type ReadonlySignerAccount,
  type ReadonlyUint8Array,
  type TransactionSigner,
  type WritableAccount,
  type WritableSignerAccount,
} from '@solana/kit';
import {
  getAccountMetaFactory,
  getAddressFromResolvedInstructionAccount,
  type ResolvedInstructionAccount,
} from '@solana/program-client-core';
import { PREDICTION_MIGRATOR_PROGRAM_ADDRESS } from '../programs';

export const REGISTER_ENTRY_DISCRIMINATOR = new Uint8Array([
  198, 25, 1, 183, 73, 219, 215, 14,
]);

export function getRegisterEntryDiscriminatorBytes() {
  return fixEncoderSize(getBytesEncoder(), 8).encode(
    REGISTER_ENTRY_DISCRIMINATOR,
  );
}

export type RegisterEntryInstruction<
  TProgram extends string = typeof PREDICTION_MIGRATOR_PROGRAM_ADDRESS,
  TAccountInitializerConfig extends string | AccountMeta<string> = string,
  TAccountLaunch extends string | AccountMeta<string> = string,
  TAccountLaunchAuthority extends string | AccountMeta<string> = string,
  TAccountBaseMint extends string | AccountMeta<string> = string,
  TAccountQuoteMint extends string | AccountMeta<string> = string,
  TAccountBaseVault extends string | AccountMeta<string> = string,
  TAccountQuoteVault extends string | AccountMeta<string> = string,
  TAccountPayer extends string | AccountMeta<string> = string,
  TAccountBaseTokenProgram extends string | AccountMeta<string> = string,
  TAccountQuoteTokenProgram extends string | AccountMeta<string> = string,
  TAccountSystemProgram extends string | AccountMeta<string> =
    '11111111111111111111111111111111',
  TAccountRent extends string | AccountMeta<string> =
    'SysvarRent111111111111111111111111111111111',
  TAccountOracle extends string | AccountMeta<string> = string,
  TAccountMarket extends string | AccountMeta<string> = string,
  TAccountPotVault extends string | AccountMeta<string> = string,
  TAccountMarketAuthority extends string | AccountMeta<string> = string,
  TAccountEntry extends string | AccountMeta<string> = string,
  TAccountEntryByMint extends string | AccountMeta<string> = string,
  TRemainingAccounts extends readonly AccountMeta<string>[] = [],
> = Instruction<TProgram> &
  InstructionWithData<ReadonlyUint8Array> &
  InstructionWithAccounts<
    [
      TAccountInitializerConfig extends string
        ? ReadonlyAccount<TAccountInitializerConfig>
        : TAccountInitializerConfig,
      TAccountLaunch extends string
        ? ReadonlyAccount<TAccountLaunch>
        : TAccountLaunch,
      TAccountLaunchAuthority extends string
        ? ReadonlySignerAccount<TAccountLaunchAuthority> &
            AccountSignerMeta<TAccountLaunchAuthority>
        : TAccountLaunchAuthority,
      TAccountBaseMint extends string
        ? ReadonlyAccount<TAccountBaseMint>
        : TAccountBaseMint,
      TAccountQuoteMint extends string
        ? ReadonlyAccount<TAccountQuoteMint>
        : TAccountQuoteMint,
      TAccountBaseVault extends string
        ? ReadonlyAccount<TAccountBaseVault>
        : TAccountBaseVault,
      TAccountQuoteVault extends string
        ? ReadonlyAccount<TAccountQuoteVault>
        : TAccountQuoteVault,
      TAccountPayer extends string
        ? WritableSignerAccount<TAccountPayer> &
            AccountSignerMeta<TAccountPayer>
        : TAccountPayer,
      TAccountBaseTokenProgram extends string
        ? ReadonlyAccount<TAccountBaseTokenProgram>
        : TAccountBaseTokenProgram,
      TAccountQuoteTokenProgram extends string
        ? ReadonlyAccount<TAccountQuoteTokenProgram>
        : TAccountQuoteTokenProgram,
      TAccountSystemProgram extends string
        ? ReadonlyAccount<TAccountSystemProgram>
        : TAccountSystemProgram,
      TAccountRent extends string
        ? ReadonlyAccount<TAccountRent>
        : TAccountRent,
      TAccountOracle extends string
        ? ReadonlyAccount<TAccountOracle>
        : TAccountOracle,
      TAccountMarket extends string
        ? WritableAccount<TAccountMarket>
        : TAccountMarket,
      TAccountPotVault extends string
        ? WritableAccount<TAccountPotVault>
        : TAccountPotVault,
      TAccountMarketAuthority extends string
        ? ReadonlyAccount<TAccountMarketAuthority>
        : TAccountMarketAuthority,
      TAccountEntry extends string
        ? WritableAccount<TAccountEntry>
        : TAccountEntry,
      TAccountEntryByMint extends string
        ? WritableAccount<TAccountEntryByMint>
        : TAccountEntryByMint,
      ...TRemainingAccounts,
    ]
  >;

export type RegisterEntryInstructionData = {
  discriminator: ReadonlyUint8Array;
  entryId: ReadonlyUint8Array;
};

export type RegisterEntryInstructionDataArgs = { entryId: ReadonlyUint8Array };

export function getRegisterEntryInstructionDataEncoder(): FixedSizeEncoder<RegisterEntryInstructionDataArgs> {
  return transformEncoder(
    getStructEncoder([
      ['discriminator', fixEncoderSize(getBytesEncoder(), 8)],
      ['entryId', fixEncoderSize(getBytesEncoder(), 32)],
    ]),
    (value) => ({ ...value, discriminator: REGISTER_ENTRY_DISCRIMINATOR }),
  );
}

export function getRegisterEntryInstructionDataDecoder(): FixedSizeDecoder<RegisterEntryInstructionData> {
  return getStructDecoder([
    ['discriminator', fixDecoderSize(getBytesDecoder(), 8)],
    ['entryId', fixDecoderSize(getBytesDecoder(), 32)],
  ]);
}

export function getRegisterEntryInstructionDataCodec(): FixedSizeCodec<
  RegisterEntryInstructionDataArgs,
  RegisterEntryInstructionData
> {
  return combineCodec(
    getRegisterEntryInstructionDataEncoder(),
    getRegisterEntryInstructionDataDecoder(),
  );
}

export type RegisterEntryAsyncInput<
  TAccountInitializerConfig extends string = string,
  TAccountLaunch extends string = string,
  TAccountLaunchAuthority extends string = string,
  TAccountBaseMint extends string = string,
  TAccountQuoteMint extends string = string,
  TAccountBaseVault extends string = string,
  TAccountQuoteVault extends string = string,
  TAccountPayer extends string = string,
  TAccountBaseTokenProgram extends string = string,
  TAccountQuoteTokenProgram extends string = string,
  TAccountSystemProgram extends string = string,
  TAccountRent extends string = string,
  TAccountOracle extends string = string,
  TAccountMarket extends string = string,
  TAccountPotVault extends string = string,
  TAccountMarketAuthority extends string = string,
  TAccountEntry extends string = string,
  TAccountEntryByMint extends string = string,
> = {
  initializerConfig: Address<TAccountInitializerConfig>;
  /** Launch account from initializer */
  launch: Address<TAccountLaunch>;
  /** Launch authority PDA - signed by initializer */
  launchAuthority: TransactionSigner<TAccountLaunchAuthority>;
  /** Base mint for this entry */
  baseMint: Address<TAccountBaseMint>;
  /** Quote mint for this market */
  quoteMint: Address<TAccountQuoteMint>;
  /** Base vault from launch */
  baseVault: Address<TAccountBaseVault>;
  /** Quote vault from launch */
  quoteVault: Address<TAccountQuoteVault>;
  payer: TransactionSigner<TAccountPayer>;
  baseTokenProgram: Address<TAccountBaseTokenProgram>;
  quoteTokenProgram: Address<TAccountQuoteTokenProgram>;
  systemProgram?: Address<TAccountSystemProgram>;
  rent?: Address<TAccountRent>;
  /** The oracle that this market is tied to */
  oracle: Address<TAccountOracle>;
  /** Market PDA - created if first entry */
  market?: Address<TAccountMarket>;
  /** Pot vault for holding quote tokens */
  potVault?: Address<TAccountPotVault>;
  marketAuthority?: Address<TAccountMarketAuthority>;
  /** Entry PDA for this entry */
  entry: Address<TAccountEntry>;
  /** EntryByMint PDA for reverse lookup */
  entryByMint?: Address<TAccountEntryByMint>;
  entryId: RegisterEntryInstructionDataArgs['entryId'];
};

export async function getRegisterEntryInstructionAsync<
  TAccountInitializerConfig extends string,
  TAccountLaunch extends string,
  TAccountLaunchAuthority extends string,
  TAccountBaseMint extends string,
  TAccountQuoteMint extends string,
  TAccountBaseVault extends string,
  TAccountQuoteVault extends string,
  TAccountPayer extends string,
  TAccountBaseTokenProgram extends string,
  TAccountQuoteTokenProgram extends string,
  TAccountSystemProgram extends string,
  TAccountRent extends string,
  TAccountOracle extends string,
  TAccountMarket extends string,
  TAccountPotVault extends string,
  TAccountMarketAuthority extends string,
  TAccountEntry extends string,
  TAccountEntryByMint extends string,
  TProgramAddress extends Address = typeof PREDICTION_MIGRATOR_PROGRAM_ADDRESS,
>(
  input: RegisterEntryAsyncInput<
    TAccountInitializerConfig,
    TAccountLaunch,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountPayer,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountSystemProgram,
    TAccountRent,
    TAccountOracle,
    TAccountMarket,
    TAccountPotVault,
    TAccountMarketAuthority,
    TAccountEntry,
    TAccountEntryByMint
  >,
  config?: { programAddress?: TProgramAddress },
): Promise<
  RegisterEntryInstruction<
    TProgramAddress,
    TAccountInitializerConfig,
    TAccountLaunch,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountPayer,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountSystemProgram,
    TAccountRent,
    TAccountOracle,
    TAccountMarket,
    TAccountPotVault,
    TAccountMarketAuthority,
    TAccountEntry,
    TAccountEntryByMint
  >
> {
  // Program address.
  const programAddress =
    config?.programAddress ?? PREDICTION_MIGRATOR_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    initializerConfig: {
      value: input.initializerConfig ?? null,
      isWritable: false,
    },
    launch: { value: input.launch ?? null, isWritable: false },
    launchAuthority: {
      value: input.launchAuthority ?? null,
      isWritable: false,
    },
    baseMint: { value: input.baseMint ?? null, isWritable: false },
    quoteMint: { value: input.quoteMint ?? null, isWritable: false },
    baseVault: { value: input.baseVault ?? null, isWritable: false },
    quoteVault: { value: input.quoteVault ?? null, isWritable: false },
    payer: { value: input.payer ?? null, isWritable: true },
    baseTokenProgram: {
      value: input.baseTokenProgram ?? null,
      isWritable: false,
    },
    quoteTokenProgram: {
      value: input.quoteTokenProgram ?? null,
      isWritable: false,
    },
    systemProgram: { value: input.systemProgram ?? null, isWritable: false },
    rent: { value: input.rent ?? null, isWritable: false },
    oracle: { value: input.oracle ?? null, isWritable: false },
    market: { value: input.market ?? null, isWritable: true },
    potVault: { value: input.potVault ?? null, isWritable: true },
    marketAuthority: {
      value: input.marketAuthority ?? null,
      isWritable: false,
    },
    entry: { value: input.entry ?? null, isWritable: true },
    entryByMint: { value: input.entryByMint ?? null, isWritable: true },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Original args.
  const args = { ...input };

  // Resolve default values.
  if (!accounts.systemProgram.value) {
    accounts.systemProgram.value =
      '11111111111111111111111111111111' as Address<'11111111111111111111111111111111'>;
  }
  if (!accounts.rent.value) {
    accounts.rent.value =
      'SysvarRent111111111111111111111111111111111' as Address<'SysvarRent111111111111111111111111111111111'>;
  }
  if (!accounts.market.value) {
    accounts.market.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(new Uint8Array([109, 97, 114, 107, 101, 116])),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'oracle',
            accounts.oracle.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'quoteMint',
            accounts.quoteMint.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.potVault.value) {
    accounts.potVault.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([112, 111, 116, 95, 118, 97, 117, 108, 116]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'market',
            accounts.market.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.marketAuthority.value) {
    accounts.marketAuthority.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([
            109, 97, 114, 107, 101, 116, 95, 97, 117, 116, 104, 111, 114, 105,
            116, 121,
          ]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'market',
            accounts.market.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.entryByMint.value) {
    accounts.entryByMint.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([
            101, 110, 116, 114, 121, 95, 98, 121, 95, 109, 105, 110, 116,
          ]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'market',
            accounts.market.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'baseMint',
            accounts.baseMint.value,
          ),
        ),
      ],
    });
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('initializerConfig', accounts.initializerConfig),
      getAccountMeta('launch', accounts.launch),
      getAccountMeta('launchAuthority', accounts.launchAuthority),
      getAccountMeta('baseMint', accounts.baseMint),
      getAccountMeta('quoteMint', accounts.quoteMint),
      getAccountMeta('baseVault', accounts.baseVault),
      getAccountMeta('quoteVault', accounts.quoteVault),
      getAccountMeta('payer', accounts.payer),
      getAccountMeta('baseTokenProgram', accounts.baseTokenProgram),
      getAccountMeta('quoteTokenProgram', accounts.quoteTokenProgram),
      getAccountMeta('systemProgram', accounts.systemProgram),
      getAccountMeta('rent', accounts.rent),
      getAccountMeta('oracle', accounts.oracle),
      getAccountMeta('market', accounts.market),
      getAccountMeta('potVault', accounts.potVault),
      getAccountMeta('marketAuthority', accounts.marketAuthority),
      getAccountMeta('entry', accounts.entry),
      getAccountMeta('entryByMint', accounts.entryByMint),
    ],
    data: getRegisterEntryInstructionDataEncoder().encode(
      args as RegisterEntryInstructionDataArgs,
    ),
    programAddress,
  } as RegisterEntryInstruction<
    TProgramAddress,
    TAccountInitializerConfig,
    TAccountLaunch,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountPayer,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountSystemProgram,
    TAccountRent,
    TAccountOracle,
    TAccountMarket,
    TAccountPotVault,
    TAccountMarketAuthority,
    TAccountEntry,
    TAccountEntryByMint
  >);
}

export type RegisterEntryInput<
  TAccountInitializerConfig extends string = string,
  TAccountLaunch extends string = string,
  TAccountLaunchAuthority extends string = string,
  TAccountBaseMint extends string = string,
  TAccountQuoteMint extends string = string,
  TAccountBaseVault extends string = string,
  TAccountQuoteVault extends string = string,
  TAccountPayer extends string = string,
  TAccountBaseTokenProgram extends string = string,
  TAccountQuoteTokenProgram extends string = string,
  TAccountSystemProgram extends string = string,
  TAccountRent extends string = string,
  TAccountOracle extends string = string,
  TAccountMarket extends string = string,
  TAccountPotVault extends string = string,
  TAccountMarketAuthority extends string = string,
  TAccountEntry extends string = string,
  TAccountEntryByMint extends string = string,
> = {
  initializerConfig: Address<TAccountInitializerConfig>;
  /** Launch account from initializer */
  launch: Address<TAccountLaunch>;
  /** Launch authority PDA - signed by initializer */
  launchAuthority: TransactionSigner<TAccountLaunchAuthority>;
  /** Base mint for this entry */
  baseMint: Address<TAccountBaseMint>;
  /** Quote mint for this market */
  quoteMint: Address<TAccountQuoteMint>;
  /** Base vault from launch */
  baseVault: Address<TAccountBaseVault>;
  /** Quote vault from launch */
  quoteVault: Address<TAccountQuoteVault>;
  payer: TransactionSigner<TAccountPayer>;
  baseTokenProgram: Address<TAccountBaseTokenProgram>;
  quoteTokenProgram: Address<TAccountQuoteTokenProgram>;
  systemProgram?: Address<TAccountSystemProgram>;
  rent?: Address<TAccountRent>;
  /** The oracle that this market is tied to */
  oracle: Address<TAccountOracle>;
  /** Market PDA - created if first entry */
  market: Address<TAccountMarket>;
  /** Pot vault for holding quote tokens */
  potVault: Address<TAccountPotVault>;
  marketAuthority: Address<TAccountMarketAuthority>;
  /** Entry PDA for this entry */
  entry: Address<TAccountEntry>;
  /** EntryByMint PDA for reverse lookup */
  entryByMint: Address<TAccountEntryByMint>;
  entryId: RegisterEntryInstructionDataArgs['entryId'];
};

export function getRegisterEntryInstruction<
  TAccountInitializerConfig extends string,
  TAccountLaunch extends string,
  TAccountLaunchAuthority extends string,
  TAccountBaseMint extends string,
  TAccountQuoteMint extends string,
  TAccountBaseVault extends string,
  TAccountQuoteVault extends string,
  TAccountPayer extends string,
  TAccountBaseTokenProgram extends string,
  TAccountQuoteTokenProgram extends string,
  TAccountSystemProgram extends string,
  TAccountRent extends string,
  TAccountOracle extends string,
  TAccountMarket extends string,
  TAccountPotVault extends string,
  TAccountMarketAuthority extends string,
  TAccountEntry extends string,
  TAccountEntryByMint extends string,
  TProgramAddress extends Address = typeof PREDICTION_MIGRATOR_PROGRAM_ADDRESS,
>(
  input: RegisterEntryInput<
    TAccountInitializerConfig,
    TAccountLaunch,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountPayer,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountSystemProgram,
    TAccountRent,
    TAccountOracle,
    TAccountMarket,
    TAccountPotVault,
    TAccountMarketAuthority,
    TAccountEntry,
    TAccountEntryByMint
  >,
  config?: { programAddress?: TProgramAddress },
): RegisterEntryInstruction<
  TProgramAddress,
  TAccountInitializerConfig,
  TAccountLaunch,
  TAccountLaunchAuthority,
  TAccountBaseMint,
  TAccountQuoteMint,
  TAccountBaseVault,
  TAccountQuoteVault,
  TAccountPayer,
  TAccountBaseTokenProgram,
  TAccountQuoteTokenProgram,
  TAccountSystemProgram,
  TAccountRent,
  TAccountOracle,
  TAccountMarket,
  TAccountPotVault,
  TAccountMarketAuthority,
  TAccountEntry,
  TAccountEntryByMint
> {
  // Program address.
  const programAddress =
    config?.programAddress ?? PREDICTION_MIGRATOR_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    initializerConfig: {
      value: input.initializerConfig ?? null,
      isWritable: false,
    },
    launch: { value: input.launch ?? null, isWritable: false },
    launchAuthority: {
      value: input.launchAuthority ?? null,
      isWritable: false,
    },
    baseMint: { value: input.baseMint ?? null, isWritable: false },
    quoteMint: { value: input.quoteMint ?? null, isWritable: false },
    baseVault: { value: input.baseVault ?? null, isWritable: false },
    quoteVault: { value: input.quoteVault ?? null, isWritable: false },
    payer: { value: input.payer ?? null, isWritable: true },
    baseTokenProgram: {
      value: input.baseTokenProgram ?? null,
      isWritable: false,
    },
    quoteTokenProgram: {
      value: input.quoteTokenProgram ?? null,
      isWritable: false,
    },
    systemProgram: { value: input.systemProgram ?? null, isWritable: false },
    rent: { value: input.rent ?? null, isWritable: false },
    oracle: { value: input.oracle ?? null, isWritable: false },
    market: { value: input.market ?? null, isWritable: true },
    potVault: { value: input.potVault ?? null, isWritable: true },
    marketAuthority: {
      value: input.marketAuthority ?? null,
      isWritable: false,
    },
    entry: { value: input.entry ?? null, isWritable: true },
    entryByMint: { value: input.entryByMint ?? null, isWritable: true },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Original args.
  const args = { ...input };

  // Resolve default values.
  if (!accounts.systemProgram.value) {
    accounts.systemProgram.value =
      '11111111111111111111111111111111' as Address<'11111111111111111111111111111111'>;
  }
  if (!accounts.rent.value) {
    accounts.rent.value =
      'SysvarRent111111111111111111111111111111111' as Address<'SysvarRent111111111111111111111111111111111'>;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('initializerConfig', accounts.initializerConfig),
      getAccountMeta('launch', accounts.launch),
      getAccountMeta('launchAuthority', accounts.launchAuthority),
      getAccountMeta('baseMint', accounts.baseMint),
      getAccountMeta('quoteMint', accounts.quoteMint),
      getAccountMeta('baseVault', accounts.baseVault),
      getAccountMeta('quoteVault', accounts.quoteVault),
      getAccountMeta('payer', accounts.payer),
      getAccountMeta('baseTokenProgram', accounts.baseTokenProgram),
      getAccountMeta('quoteTokenProgram', accounts.quoteTokenProgram),
      getAccountMeta('systemProgram', accounts.systemProgram),
      getAccountMeta('rent', accounts.rent),
      getAccountMeta('oracle', accounts.oracle),
      getAccountMeta('market', accounts.market),
      getAccountMeta('potVault', accounts.potVault),
      getAccountMeta('marketAuthority', accounts.marketAuthority),
      getAccountMeta('entry', accounts.entry),
      getAccountMeta('entryByMint', accounts.entryByMint),
    ],
    data: getRegisterEntryInstructionDataEncoder().encode(
      args as RegisterEntryInstructionDataArgs,
    ),
    programAddress,
  } as RegisterEntryInstruction<
    TProgramAddress,
    TAccountInitializerConfig,
    TAccountLaunch,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountPayer,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountSystemProgram,
    TAccountRent,
    TAccountOracle,
    TAccountMarket,
    TAccountPotVault,
    TAccountMarketAuthority,
    TAccountEntry,
    TAccountEntryByMint
  >);
}

export type ParsedRegisterEntryInstruction<
  TProgram extends string = typeof PREDICTION_MIGRATOR_PROGRAM_ADDRESS,
  TAccountMetas extends readonly AccountMeta[] = readonly AccountMeta[],
> = {
  programAddress: Address<TProgram>;
  accounts: {
    initializerConfig: TAccountMetas[0];
    /** Launch account from initializer */
    launch: TAccountMetas[1];
    /** Launch authority PDA - signed by initializer */
    launchAuthority: TAccountMetas[2];
    /** Base mint for this entry */
    baseMint: TAccountMetas[3];
    /** Quote mint for this market */
    quoteMint: TAccountMetas[4];
    /** Base vault from launch */
    baseVault: TAccountMetas[5];
    /** Quote vault from launch */
    quoteVault: TAccountMetas[6];
    payer: TAccountMetas[7];
    baseTokenProgram: TAccountMetas[8];
    quoteTokenProgram: TAccountMetas[9];
    systemProgram: TAccountMetas[10];
    rent: TAccountMetas[11];
    /** The oracle that this market is tied to */
    oracle: TAccountMetas[12];
    /** Market PDA - created if first entry */
    market: TAccountMetas[13];
    /** Pot vault for holding quote tokens */
    potVault: TAccountMetas[14];
    marketAuthority: TAccountMetas[15];
    /** Entry PDA for this entry */
    entry: TAccountMetas[16];
    /** EntryByMint PDA for reverse lookup */
    entryByMint: TAccountMetas[17];
  };
  data: RegisterEntryInstructionData;
};

export function parseRegisterEntryInstruction<
  TProgram extends string,
  TAccountMetas extends readonly AccountMeta[],
>(
  instruction: Instruction<TProgram> &
    InstructionWithAccounts<TAccountMetas> &
    InstructionWithData<ReadonlyUint8Array>,
): ParsedRegisterEntryInstruction<TProgram, TAccountMetas> {
  if (instruction.accounts.length < 18) {
    throw new SolanaError(
      SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
      {
        actualAccountMetas: instruction.accounts.length,
        expectedAccountMetas: 18,
      },
    );
  }
  let accountIndex = 0;
  const getNextAccount = () => {
    const accountMeta = (instruction.accounts as TAccountMetas)[accountIndex]!;
    accountIndex += 1;
    return accountMeta;
  };
  return {
    programAddress: instruction.programAddress,
    accounts: {
      initializerConfig: getNextAccount(),
      launch: getNextAccount(),
      launchAuthority: getNextAccount(),
      baseMint: getNextAccount(),
      quoteMint: getNextAccount(),
      baseVault: getNextAccount(),
      quoteVault: getNextAccount(),
      payer: getNextAccount(),
      baseTokenProgram: getNextAccount(),
      quoteTokenProgram: getNextAccount(),
      systemProgram: getNextAccount(),
      rent: getNextAccount(),
      oracle: getNextAccount(),
      market: getNextAccount(),
      potVault: getNextAccount(),
      marketAuthority: getNextAccount(),
      entry: getNextAccount(),
      entryByMint: getNextAccount(),
    },
    data: getRegisterEntryInstructionDataDecoder().decode(instruction.data),
  };
}
